import useTheme from "hooks/useTheme";

const Contacts = () => {
	const { appLanguage, themeColor } = useTheme();

	return (
		<div className="flex flex-col w-full items-center justify-center col-span-2 py-2 px-3 space-y-6">
			<div className="flex w-full items-center justify-center">
				<p className={`text-md font-bold ${themeColor?.text}`}>{appLanguage?.comingSoon}</p>
			</div>
			<div className="flex flex-col w-full items-center justify-center space-y-2">
				<img className="w-32" src={`${process.env.PUBLIC_URL}/media/Blockchain-ID-block.png`} alt="logo" />
				{/* <div className="flex flex-col w-full items-center justify-center">
					<p className={`text-sm ${themeColor?.text}`}>Manage the services you</p>
					<p className={`text-sm ${themeColor?.text}`}>are registered to</p>
				</div> */}
			</div>
			<div className="flex flex-col w-full items-center justify-center">
				{/* <div className="flex">
					<p className={`text-2xl font-bold italic text-[#F59521]`}>Blockchain</p>
					<p className={`text-2xl font-bold text-burned-orange`}>ID</p>
					<p className={`text-2xl font-bold italic text-[#F59521]`}>me</p>
				</div> */}

				<img className="w-40" src={`${process.env.PUBLIC_URL}/media/BlockchainIDme-Text-Logo-for-App.png`} alt="logo" />
				<p className={`text-sm text-[#F59521]`}>{appLanguage?.selfSovereignIdentity}</p>
			</div>
			<div className="flex flex-col w-full items-center justify-center">
				<p
					className={`text-sm text-center ${themeColor?.text}`}
					dangerouslySetInnerHTML={{ __html: appLanguage?.identityValidationFor }}
				/>
			</div>

			<div className="flex flex-col w-full items-center justify-center space-y-2">
				<p className={`text-sm ${themeColor?.text}`}>{appLanguage?.poweredBy}</p>
				<img className="w-24" src={`${process.env.PUBLIC_URL}/media/Veratad-Technologies-Logo.jpg`} alt="logo" />
			</div>
		</div>
	);
};

export default Contacts;
